import DynamicCardFeed from '../scripts/sections/DynamicCardFeed';
import DynamicCollectionGrid from '../scripts/sections/DynamicCollectionGrid';
import DynamicContentColumns from '../scripts/sections/DynamicContentColumns';
import DynamicFeaturedProduct from '../scripts/sections/DynamicFeaturedProduct';
import DynamicMarqueeBanner from '../scripts/sections/DynamicMarqueeBanner';
import DynamicProductFeed from '../scripts/sections/DynamicProductFeed';
import DynamicWallOfShame from '../scripts/sections/DynamicWallOfShame';

// Sections
import MainCart from '../scripts/sections/MainCart';
import MainCollection from '../scripts/sections/MainCollection';
import MainHeader from '../scripts/sections/MainHeader';
import MainMinicart from '../scripts/sections/MainMinicart';
import MainProduct from '../scripts/sections/MainProduct';
import Sections from '../scripts/helpers/SectionManager';

import detectSafari from '../scripts/global/detectSafari';
import initAOS from '../scripts/global/initAos';
import initModals from '../scripts/global/initModals';
import initVideos from '../scripts/global/initVideos';

// Init global sections
const sections = new Sections();
sections.register('main-product', section => new MainProduct(section));
sections.register(
  'main-collection-grid',
  section => new MainCollection(section),
);
sections.register('main-header', section => new MainHeader(section));
sections.register('main-minicart', section => new MainMinicart(section));
sections.register('main-cart', section => new MainCart(section));
sections.register('main-search', section => new MainCollection(section));

sections.register(
  'dynamic-card-feed',
  section => new DynamicCardFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-collection-grid',
  section => new DynamicCollectionGrid(section),
  { lazy: true },
);
sections.register(
  'dynamic-content-columns',
  section => new DynamicContentColumns(section),
  { lazy: true },
);
sections.register(
  'dynamic-product-feed',
  section => new DynamicProductFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-featured-product',
  section => new DynamicFeaturedProduct(section),
  {
    lazy: true,
  },
);
sections.register(
  'dynamic-marquee-banner',
  section => new DynamicMarqueeBanner(section),
);
sections.register(
  'dynamic-wall-of-shame',
  section => new DynamicWallOfShame(section),
  { lazy: true },
);

initAOS();
initVideos();
initModals();
detectSafari();
